
import io from 'socket.io-client';


const socketServerNexmo = io(`${process.env.RAZZLE_REACT_APP_API_DOMAIN}`, { forceNew: true, transports: ['websocket'] });

export default socketServerNexmo;
